<template>
  <div class="toolbar">
    <div class="grad"></div>
    <div class="tools">
      <div  class="tool" v-for="item in tools" :key="item.id"  @click="activate(item.id)">
        <img :src="`toolbar-icons/${item.id}-${value === item.id ? 'active' : 'inactive'}.svg`" alt="" srcset="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: 'map'
    }
  },
  data () {
    return {
      tools: [
        { id: 'customers' }
        // { id: 'stats' }
      ]
    }
  },
  methods: {
    activate (tool) {
      this.$emit('input', tool)
    }
  }
}
</script>

<style lang="scss">
.toolbar {
  width: 72px;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  .grad {
    width: 72px;
    height: 17.5px;
    opacity: 0.2;
    background-image: linear-gradient(to bottom, #000000, rgba(0, 0, 0, 0));
  }
  .tools {
    display: flex;
    flex-direction: column;
    align-items: center;
    .tool {
      margin: 20px 0;
      img  {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
